<div class="full-screen-popup" [ngClass]="type === 'overlayPopup' ? 'backdrop-popup' : ''">
  <div [ngClass]="type === 'overlayPopup' ? 'full-screen-nomination-popup' : ''">
    <div class="full-screen-popup-header">
      <div class="header">{{header}}</div>
      <div class="spacer"></div>
      <i *ngIf="type === 'overlayPopup'" class="fa fa-close" (click)="onClose.emit()"></i>
      <app-button *ngIf="type !== 'overlayPopup'" [name]="'close'" [type]="'close-outlined'" (btnClick)="onClose.emit()">
      </app-button>
    </div>
    <div class="full-screen-popup-body">
      <ng-content></ng-content>
    </div>
    <div *ngIf="type === 'overlayPopup'" class="full-screen-popup-footer">
      <app-sticky-bottom-btns>
        <span class="add-button">
          <!-- <div *ngIf="workflowStatus == '2'">
            <div ngbDropdown container="body">
              <button class="custom-btn" ngbDropdownToggle>Reject</button>
              <div ngbDropdownMenu>
                <button ngbDropdownItem (click)="rejectUpdateRequired.emit()">Reject (update required)</button>
                <button ngbDropdownItem (click)="rejectApplicant.emit()"> Reject applicant</button>
              </div>
            </div>
          </div> -->
          <app-button [disable]="isReportingCycleLocked" *ngIf="isORC && workflowUser === loginUserId && showNominationButton && yearCode === currentReportingCycleYear" [name]="'Approve'" [type]="'confirm float-left'" (btnClick)="onORCApprove.emit()"></app-button>
          <app-button [disable]="isReportingCycleLocked" *ngIf="isORC && workflowUser === loginUserId && showNominationButton && yearCode === currentReportingCycleYear" [name]="'Reject applicant'" [type]="'delete-confirm float-left'" (btnClick)="rejectApplicant.emit()"></app-button>
          <app-button [disable]="isReportingCycleLocked" *ngIf="isORC && workflowUser === loginUserId && showNominationButton && yearCode === currentReportingCycleYear" [name]="'Reject (update required)'" [type]="'delete-confirm float-left'" (btnClick)="rejectUpdateRequired.emit()"></app-button>


          <app-button [disable]="isReportingCycleLocked" *ngIf="isEndorser && workflowUser === loginUserId && showNominationButton && yearCode === currentReportingCycleYear" [name]="'Approve'" [type]="'confirm float-left'" (btnClick)="onEndorserApprove.emit()"></app-button>
          <app-button [disable]="isReportingCycleLocked" *ngIf="isEndorser && workflowUser === loginUserId && showNominationButton && yearCode === currentReportingCycleYear" [name]="'Reject'" [type]="'delete-confirm float-left'" (btnClick)="onEndorserReject.emit()"></app-button>


          <app-button  [tooltiptext]="affiliationNotPreset ? disableNominationToolTip: null"
          [disable]="formName === 'nomination' ? isReportingCycleLocked || affiliationNotPreset : isReportingCycleLocked"
          *ngIf="isCPQPORC && workflowUser === loginUserId && !readonlyForm && showNominationButton && yearCode === currentReportingCycleYear" [name]="formName === 'nomination' ? 'Submit Nomination' : 'Consent To Publish'"
           [type]="'bhp-fill float-left'" (btnClick)="onSubmitNomination.emit()"></app-button>
          <app-button [name]="'Cancel'" [type]="'outlined float-left'" (btnClick)="onClose.emit()"></app-button>
        </span>
      </app-sticky-bottom-btns>
    </div>
  </div>
</div>
